<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1200px"
    @close="handleClose"
  >
    <span slot="title">
      <span class="center-title">
        {{ mode === 'edit' ? '更换海报商品' : '海报指定商品范围' }}
      </span>
      <span class="tips">
        {{ mode === 'edit' ? '默认显示已选范围商品，也可更换范围选择，最多10个商品' : '以下是小店商品，可选择海报要展示的指定商品范围' }}
      </span>
    </span>
    <div class="import-center">
      <Search
        ref="search"
        @search="search"
        :initialParams="initialParams"
      />
      <Table
        ref="table"
        :list="list"
        @updateSelectedArr="updateSelectedArr"
      />
      <el-pagination
        :style="{ padding: '8px 16px', textAlign: 'right' }"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer flex space-between pdlr20">
      <div>
        已选择
        <span class="text-orange">
          {{selectedArr.length}}
        </span>
        款商品
      </div>
      <div>
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="onOk">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Search from "./search";
import Table from "./table";
import { getShopItemList } from '@/servers/commodity'
import { get } from 'lodash';

export default {
  data() {
    return {
      dialogVisible: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      list: [],
      outerIds: [],
      mode: 'add',
      selectedArr: [],
      initialParams: null,
      goodsRange: 1,
    };
  },
  components: {
    Search,
    Table,
  },
  methods: {
    handleClose() {
      this.$emit("search");
    },
    method_open(mode = 'add', {
      goodsRange,
      initialParams,
    }) {
      this.goodsRange = goodsRange;
      // 如果商品范围是指定商品，设置表格初始参数
      if (goodsRange === 3 && initialParams) {
        this.initialParams = initialParams;
      }
      this.mode = mode;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.search();
      });
    },
    // 搜索触发
    search() {
      this.pagination.pageNo = 1;
      this.fetch_list();
    },
    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetch_list();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.fetch_list();
    },
    async fetch_list() {
      const { pageNo, pageSize } = this.pagination;
      const searchParams = this.$refs.search.method_getSearchForm();
      const _params = {
        pageNo,
        pageSize,
        ...searchParams,
      };
      const res = await getShopItemList(_params);
      if (!res) return;
      const { total, records } = res;
      this.list = records;
      this.pagination.total = total;
    },

    updateSelectedArr(arr) {
      this.selectedArr = arr;
    },

    onOk() {
      let arr = this.$refs.table.method_getSelectedArr();
      if (!arr.length) {
        this.$message.warning('当前未选择任何商品');
        return;
      }
      if (arr.length > 10) {
        this.$message.warning('选择商品不能超过10个');
        return;
      }
      this.dialogVisible = false;
      this.$emit('closePopover');
      this.$emit('handleChoose', arr, this.goodsRange);
      // 选择成功后设置商品范围为指定商品
      this.$emit('updateGoodsRange', this.goodsRange);
    },

    handleCancel() {
      this.dialogVisible = false;
      this.$refs.search.clear(false);
      if (this.goodsRange === 3) {
        this.$emit('closePopover', true);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.btns {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.center-title {
  line-height: 24px;
  font-size: 14px;
  color: #fff;
}
.tips {
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  color: #fff;
  opacity: 0.6;
}
</style>
